// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jTJF","content":"styles_content__2M-3w"};